/**
 * Build facts for pin feedback, injected by vite.config.ts at build time (`define`): the git revision the web app was
 * built from (GIRAFFE_BUILD_SHA, or `git rev-parse --short HEAD`) and the contract version (contracts/openapi.yaml
 * info.version). "unknown" when not injected.
 */
declare const __GIRAFFE_BUILD_SHA__: string | undefined;
declare const __GIRAFFE_CONTRACT_VERSION__: string | undefined;

export const BUILD_SHA: string = typeof __GIRAFFE_BUILD_SHA__ === "string" ? __GIRAFFE_BUILD_SHA__ : "unknown";
export const CONTRACT_VERSION: string = typeof __GIRAFFE_CONTRACT_VERSION__ === "string" ? __GIRAFFE_CONTRACT_VERSION__ : "unknown";
